$('.section-places .section__head').on('click',function() {
	let $this = $(this);

	$this.toggleClass('active').next().slideToggle();
});